import {
  Component,
  ComponentInterface,
  h,
  Prop,
} from '@stencil/core';

import { InterfaceUtilizationItem } from './paf-result-utilization.custom';

@Component({
  shadow: true,
  styleUrl: 'paf-result-utilization.scss',
  tag: 'paf-result-utilization',
})

export class PafResultUtilization implements ComponentInterface {

  /**
   * Stringified JSON which defines most of the
   * content of the component. Please check the
   * individual stories to get an idea of the
   * structure.
   */
  @Prop() public config!: string;

  /**
   * Level defines whether the component is used on
   * timetable level 1 or 2. The value we pass
   * into the component will define the size of
   * the icons.
   */
  @Prop() public level!: string;

  public render(): HTMLDivElement {
    const utilizationItems: InterfaceUtilizationItem = JSON.parse(this.config);

    return (
      <ul
        class={`utilization-list utilization-list--level-${this.level}`}
      >
        {utilizationItems.utilizationItems.map((utilizationItem) => (
          <li>
            <paf-result-utilization-icon
              travelClass={utilizationItem.travelClass}
              utilization={utilizationItem.utilization}
            >
            </paf-result-utilization-icon>
          </li>
        ))}
      </ul>
    );
  }
}
